import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/app/AppShell";
import LoginPage from "@/pages/LoginPage";
import AdminConsolePage from "@/pages/AdminConsolePage";
import BriefingPage from "@/pages/BriefingPage";
import FlowPage from "@/pages/FlowPage";
import EvidenceRoomPage from "@/pages/EvidenceRoomPage";
import LaunchConsolePage from "@/pages/LaunchConsolePage";
import AgentStudioPage from "@/pages/AgentStudioPage";
import TriadReviewPage from "@/pages/TriadReviewPage";
import MatrixPage from "@/pages/MatrixPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import ControlTowerPage from "@/pages/ControlTowerPage";
import QuestionBuilderPage from "@/pages/QuestionBuilderPage";
import PilotBoardPage from "@/pages/PilotBoardPage";
import ImpactEnginePage from "@/pages/ImpactEnginePage";
import CommsStudioPage from "@/pages/CommsStudioPage";
import CommandCenterPage from "@/pages/CommandCenterPage";
import ReportBuilderPage from "@/pages/ReportBuilderPage";
import ChangeManagementPage from "@/pages/ChangeManagementPage";
import TransformationOSPage from "@/pages/TransformationOSPage";
import DataIntakeHubPage from "@/pages/DataIntakeHubPage";
import DataMappingStudioPage from "@/pages/DataMappingStudioPage";
import AugustForensicPage from "@/pages/AugustForensicPage";
import LiveAgentRunsPage from "@/pages/LiveAgentRunsPage";
import SOPBuilderPage from "@/pages/SOPBuilderPage";

const RequireAuth = ({ children }) => {
  const { user, booting } = useAuth();
  if (booting) {
    return (
      <div className="h-screen flex items-center justify-center bg-[--shell-0]">
        <div className="text-xs font-mono uppercase tracking-widest text-[--tx-3]">Loading workspace...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<RequireAuth><AppShell /></RequireAuth>}>
              <Route path="/" element={<Navigate to="/overview" replace />} />
              <Route path="/admin" element={<AdminConsolePage />} />
            <Route path="/overview" element={<TransformationOSPage />} />
            <Route path="/briefing" element={<BriefingPage />} />
            <Route path="/flow" element={<FlowPage />} />
            <Route path="/evidence" element={<EvidenceRoomPage />} />
            <Route path="/launch" element={<LaunchConsolePage />} />
            <Route path="/agents" element={<AgentStudioPage />} />
            <Route path="/triad" element={<TriadReviewPage />} />
            <Route path="/matrix" element={<MatrixPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/control-tower" element={<ControlTowerPage />} />
            <Route path="/questions" element={<QuestionBuilderPage />} />
            <Route path="/pilots" element={<PilotBoardPage />} />
            <Route path="/brightspeed" element={<ChangeManagementPage />} />
            <Route path="/change" element={<Navigate to="/brightspeed" replace />} />
            <Route path="/impact-engine" element={<ImpactEnginePage />} />
            <Route path="/comms" element={<CommsStudioPage />} />
            <Route path="/command-center" element={<CommandCenterPage />} />
            <Route path="/reports" element={<ReportBuilderPage />} />
            <Route path="/live/intake" element={<DataIntakeHubPage />} />
            <Route path="/live/mapping" element={<DataMappingStudioPage />} />
            <Route path="/live/forensic" element={<AugustForensicPage />} />
            <Route path="/live/runs" element={<LiveAgentRunsPage />} />
            <Route path="/live/sop" element={<SOPBuilderPage />} />
            <Route path="*" element={<Navigate to="/overview" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      </AppProvider>
    </AuthProvider>
  );
}

export default App;
